import { createConfig, http } from 'wagmi'
import { base, baseSepolia } from 'viem/chains'
import { walletConnect, coinbaseWallet, injected } from '@wagmi/connectors'

// Get WalletConnect project ID from environment or use placeholder
// Get your free project ID at: https://cloud.walletconnect.com
const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || 'YOUR_PROJECT_ID_HERE'

// Determine which chain to use based on environment
const nodeEnv = import.meta.env.VITE_NODE_ENV || import.meta.env.MODE
const isDevelopment = nodeEnv === 'development'
const chain = isDevelopment ? baseSepolia : base

export const config = createConfig({
  chains: [chain],
  connectors: [
    // Injected connector (MetaMask, Rainbow, etc.)
    injected(),
    
    // WalletConnect (mobile wallets including Base Wallet)
    walletConnect({
      projectId,
      metadata: {
        name: 'Zoombies Bonez',
        description: 'Purchase Chipz for Zoombies game',
        url: typeof window !== 'undefined' ? window.location.origin : '',
        icons: [typeof window !== 'undefined' ? `${window.location.origin}/bonez/logo512.png` : ''],
      },
      showQrModal: true, // Shows QR code for mobile wallet connection
    }),
    
    // Coinbase Wallet
    coinbaseWallet({
      appName: 'Zoombies Bonez',
      appLogoUrl: typeof window !== 'undefined' ? `${window.location.origin}/bonez/logo512.png` : '',
    }),
  ],
  transports: {
    [base.id]: http(),
    [baseSepolia.id]: http(),
  },
})
